import { compose } from 'recompose';
import { connect } from 'react-redux';

import { PreviewLayout } from './component';
import { withOrganizationSettings } from '../common';

const mapStateToProps = ({ router: { query } }) => ({ previewToken: query.previewToken });

export default compose(
  connect(mapStateToProps),
  withOrganizationSettings,
)(PreviewLayout);



// WEBPACK FOOTER //
// ./src/layouts/preview/container.js